import FeaturesList from './feature-list/features-list';

export default FeaturesList;
